import { render, staticRenderFns } from "./PosPage.vue?vue&type=template&id=493ffc91&scoped=true"
import script from "./PosPage.vue?vue&type=script&lang=js"
export * from "./PosPage.vue?vue&type=script&lang=js"
import style0 from "./PosPage.vue?vue&type=style&index=0&id=493ffc91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ffc91",
  null
  
)

export default component.exports